export default __webpack_public_path__ + "static/media/portfolio-1.bb58c286.jpg";